import { Priority } from './constants';
import { expectActiveViewRevision } from './util';
import { dynamic } from './dynamic';
import { setPriority } from './priority';
export function applyDefaults(revision, defaults) {
    const keys = Object.keys(defaults);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        // We check for undefined to match the behavior of ES6 default assignment
        if (typeof revision.initialProps[key] === 'undefined') {
            revision.props[key] = defaults[key];
        }
    }
}
/**
 * Sets or overrides a View’s default value for one or more props.
 *
 * @see https://sail.stripe.me/apis/setdefaults
 */ export const setDefaults = (defaults)=>setPriority(Priority.High, dynamic(()=>{
        applyDefaults(expectActiveViewRevision(), defaults);
    }));

//# sourceMappingURL=setDefaults.js.map